/**
 * @author  : 王冲
 * @desc    : passport -- utils
 */
import {
    thirdAppUaReg
} from "./constants";
declare const window: any;

const publicUrlstatic = window.publicUrlstatic || window.publicUrl || '';
const publicUrlapi = window.publicUrlapi || '';
export function loadcss(csslink: string) {
    const link = document.createElement('link');
    link.setAttribute('type', 'text/css');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', csslink);
    document.body.appendChild(link);
}
//加载js文件
export function loadjs(src: string, callback: () => void) {
    let script: any = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
    script.type = 'text/javascript';
    script.charset = 'UTF-8';
    script.src = src;
    if (script.addEventListener) {
        script.addEventListener('load', function () {
            callback();
        }, false);
    } else if (script.attachEvent) {
        script.attachEvent('onreadystatechange', function () {
            var target = window.event.srcElement;
            if (target.readyState == 'loaded') {
                callback();
            }
        });
    }
    head.appendChild(script);
}
export function inFasterSpPage() {
    let whiteList = [
        '/sp/workflow/flowpage',
        '/sp/fna/flowpage',
        '/sp/odoc/flowForm'
    ], flag = false;
    whiteList.forEach((path: any) => {
        if (window.location.pathname.indexOf(path) !== -1) {
            flag = true;
        }
    })
    return flag
}
//获取地址参数
export function getQueryString(name: string) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg) || window.location.hash.match(reg);
    if (r != null) return unescape(r[2]); return null;
}
//判断第三方app登录
export function isThirdLogin() {
    let ua = window.navigator.userAgent;
    return (thirdAppUaReg.test(ua) && getQueryString('wea_link_keep_ebAgentKey')) ||
        (thirdAppUaReg.test(ua)
            && getQueryString('corpId')
            && getQueryString('suiteId')
        ) || (thirdAppUaReg.test(ua) &&
            getQueryString('ebAuthCorpId') &&
            getQueryString('ebAuthSuiteKey')
        )
}

//地址参数对象拼接
export function getSearchParams() {
    let resultObj: any = {};
    let search = window.location.search;
    if (search && search.length > 1) {
        search = search.substring(1);
        let items = search.split('&');
        for (let index = 0; index < items.length; index++) {
            if (!items[index]) {
                continue;
            }
            let kv = items[index].split('=');
            resultObj[kv[0]] = typeof kv[1] === "undefined" ? "" : kv[1];
        }
    }
    return resultObj;
}
//获取随机字符串
export function getRandomVersion(len: number) {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';
    let maxPos = chars.length;
    let str = '';
    for (let i = 0; i < len; i++) {
        str += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return str;
}
export function createUUid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
export function createTraceId() {
    return Math.random().toString(36).substr(2, 10) + '_' + new Date().getTime();
}
export function inApp() {
    if (localStorage.getItem("___test_fkjsjdfs_app")){
        return true;
    }
    return /weapp/i.test(navigator.userAgent);
}
export function inWxwork() {
    return /wxwork/i.test(navigator.userAgent);
}
export function inWechat() {
    return /MicroMessenger/i.test(navigator.userAgent);
}
export function isSpPage() {
    return window.location.pathname.replace(publicUrlstatic, '').indexOf('/sp/') === 0;
}
export function isMobileUrl() {
    return window.location.pathname.replace(publicUrlstatic, '').indexOf("/mobile") === 0;
}
export function isMobileUA() {
    return /(iPhone|iPad|iPod|iOS|Android|Mobile)/i.test(navigator.userAgent);
    // return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
}
export function isIphost() {
    const host = window.location.hostname;
    const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    return reg.test(host);
}


export function getHeaderField(type: string, url: string, field: string) {
    let xhr = new XMLHttpRequest();
    xhr.open(type, url, false);
    xhr.send(null);
    if (localStorage.getItem('eteamsid_test')) {
        alert(xhr.getAllResponseHeaders());
    }
    let result = xhr.getResponseHeader(field);
    if ((field === 'eteamsid' || field === 'ETEAMSID') && result) {
        sessionStorage.setItem('E10_ETEAMSID_LOCAL', result);
    }
    return result;
}
export function inMobileApp() {
    return !!(inApp() && isMobileUA());
}
//检查组件加载情况--所有国际化词条建到UI分类下
export function checkWeappUi(callback: any) {
    let count = 0;
    let lsTimer = setInterval(() => {
        count++;
        if (count > 10) {
            clearInterval(lsTimer);
        }
        if (window.weappUi?.Dialog &&
            window.weappUi?.MDialog &&
            window.weappUtils?.getLabel &&
            window.weappUi?.Button &&
            window.weappUi?.Icon
        ) {
            callback();
            clearInterval(lsTimer);
        }
    }, 1000);
}
//判断是否需要建立ws链接，返回对应端标识
export function getClientType() {
    let ua = window.navigator.userAgent;
    let client = null;
    // 移动端
    if (isMobileUA()) {
        if (/weapp/i.test(ua)) {
            if (/Android/i.test(ua)) {
                client = 'app-and';
            } else if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
                client = 'app-ios'
            }
        }
    } else {
        if (/weapp/i.test(ua)) {
            client = 'app-pc';
        } else {
            client = 'pc'
        }
    }
    // 屏蔽第三方app
    if (thirdAppUaReg.test(ua)) {
        return null;
    }
    //pc端
    return client;
}

//判断终端类型:pc、app-pc、h5、app-h5
export function getClientTypeWithoutMobile() {
    if (localStorage.getItem("PASSPORT_TEST_WS_CLIENT")) {
        return localStorage.getItem("PASSPORT_TEST_WS_CLIENT")
    }
    let ua = window.navigator.userAgent;
    let client = null;
    // 移动端
    if (isMobileUA()) {
        if (/weapp/i.test(ua)) {
            client = 'app-h5';
        } else {
            client = 'h5'
        }
    } else {
        if (/weapp/i.test(ua)) {
            client = 'app-pc';
        } else {
            client = 'pc'
        }
    }
    // 屏蔽第三方app
    if (thirdAppUaReg.test(ua)) {
        return null;
    }
    //pc端
    return client;
}
export function checkSocketLog() {
    return !!(window.TEAMS?.currentUser?.userId === '5114454557175732769');
}
export function checkSocketDialog() {
    return !!(window.TEAMS?.currentTenant?.tenantKey === 't5dopzehtx');
}

//此种登录拦截方式，后端会将eteamid过期
export function isLoginForbid() {
    return !!window.TEAMS?.forbidType;
}

export function isObstructPage() {
    return (
      isLoginForbid() ||
      window.TEAMS?.loginAccess === false ||
      window.TEAMS?.firstLoginUpdatePassword === true ||
      window.TEAMS?.forceUpdatePassword === true ||
      window.TEAMS?.customLoginForbid === true ||
      (window.TEAMS?.realNameConfig?.forceAuth && !window.TEAMS?.realNameConfig?.hasAuth && !window.TEAMS?.realNameConfig?.white)
    )
}

export function addDivLog(content: any) {
    if (!document.getElementById('passport_divlog')) {
        const logdiv = document.createElement('div');
        logdiv.setAttribute('id', 'passport_divlog');
        logdiv.setAttribute('style', 'font-size:14x;position:fixed;top:0;left:0;color:red;z-index:9999;background:#fff;height:100%;overflow:auto')
        document.body.appendChild(logdiv);
    }
    const date = new Date();
    const time = document.createElement('p');
    const info = document.createElement('p');
    info.innerHTML = content;
    time.innerHTML = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    const div: any = document.getElementById('passport_divlog');
    if (div) {
        div.appendChild(time);
        div.appendChild(info);
    }
}
//获取cookie
export function getCookie(name: any) {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    arr = document.cookie.match(reg);
    if (arr) {
        return unescape(arr[2]);
    }
    else {
        return null;
    }
}
export function isWindows() {//判断是否是windows
    const userAgent = navigator.userAgent.toLowerCase();
    return /windows nt/.test(userAgent);
}
export function isMac() {//判断是否是mac
    const userAgent = navigator.userAgent.toLowerCase();
    return /macintosh|mac os x/i.test(userAgent);
}
export function isXinchuang() {//信创环境
    return !isWindows() && !isMac();
}
//设置cookie
export function setCookie(name: string, value: string, domain?: string) {
    if (!domain) {
        document.cookie = name + '=' + value + ';path=/;';
    } else {
        document.cookie = name + '=' + value + ';domain=' + domain + ';path=/;';
    }
}
export function clearOneCookie(name: any) {
    let host = window.location.hostname;
    const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
    //清理当前域
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    //ip地址访问
    if (!reg.test(host)) {
        host = '.' + host;
        for (var i = 0; i < host.length; i++) {
            if (host[i] === '.') {
                let domain = host.substr(i + 1);
                document.cookie = name + "=;domain=" + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                document.cookie = name + "=;domain=." + domain + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
    }
}
//是否是beta或者正式环境
export const isProOrBetaEnv = () => {
    return (window.TEAMS?.runMode === 'beta' || window.TEAMS?.runMode === 'txproduction') && (window.TEAMS?.deploy === "public")
}
export function cloneObj(Obj: any) {
    let buf: any;
    if (Obj instanceof Array) {
        buf = [];  //创建一个空的数组
        let i = Obj.length;
        while (i--) {
            buf[i] = cloneObj(Obj[i]);
        }
        return buf;
    } else if (Obj instanceof Object) {
        buf = {};  //创建一个空对象
        for (let k in Obj) {  //为这个对象添加新的属性
            buf[k] = cloneObj(Obj[k]);
        }
        return buf;
    } else {
        return Obj;
    }
}

export const inCasLogin = () => {
    return !!sessionStorage.getItem('E10_CASLOGOUTURL')
}
export const inIframe = () => {
    return window.self !== window.top;
}
export function isIframeOpen() {
    return window.self?.frameElement?.tagName == "IFRAME";
}
export function isBackStage() {
    return window.location.pathname.indexOf(`${publicUrlstatic}/info`) === 0;
}
export function isEcodePlatform() {
    return window.location.pathname.indexOf(`${publicUrlstatic}/ecode`) === 0;
}
export const getImClientType = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    let type: any = null;

    if (/electron/i.test(ua)) {//客户端
        if (isMac()) {
            type = 7;
        } else if (isWindows()) {
            type = 9;
        } else if (/Linux/i.test(ua)) {
            type = 8
        }
    } else {
        if (isMobileUA()) {
            if (/weapp/i.test(ua)) {
                if (/Android/i.test(ua)) {
                    if (!/(?:Mobile)/i.test(ua)) {
                        type = 11
                    } else {
                        type = 1
                    }

                } else if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
                    if (/iPad/i.test(ua)) {
                        type = 3
                    } else {
                        type = 2
                    }
                }
            } else {
                type = 6;
            }

        } else {
            type = 5;
        }
    }
    return type;
}
//需要收到锁定控制的页面
export function isPageInLockControl() {
    return (
        //主框架非移动端模式
        (window.inWeappLayout && (!isMobileUA() && !isMobileUrl())) ||
        //非iframe PC单页模式
        (isSpPage() && !isIframeOpen()) ||
        //后台管理中心
        isBackStage() ||
        //ecode平台
        isEcodePlatform()
    )
}

export function getFilePreviewUrl(fileId: string, type: string = 'imgs') {
    return `${publicUrlapi}/api/file/preview?fileId=${fileId}&type=${type}`;
}

//文件权限改造兼容处理老数据
//url可能是静态资源（/static/**）、老数据（/api/file/noauth/**、/papi/file/noauth/**）
export function dealImageUrl(url: string) {
    if (!url) {
        return "";
    }
    if (url?.indexOf("/") === -1) {
        return getFilePreviewUrl(url);
    }
    return url.replace('/papi/file/noauth/', '/papi/file/preview?type=imgs&fileId=')
        .replace('/api/file/noauth/', '/api/file/preview?type=imgs&fileId=');
}

export const getBrowserLangType = (langType: string) => {//
    if (!langType) return 'zh_CN';
    if (langType === "zh-TW" || langType === "zh-HK" || langType === "zh-SG") {
        return "zh_TW"
    }
    const langTypeKey = langType.split('-')[0].toLocaleLowerCase();
    const langTypePool = [
        'zh_CN',
        'en_US',
        'zh_TW',
        'ko_KR',
        'ru_RU',
        'ja_JP',
        'th_TH',
        'es_ES',
        'de_DE',
        'fr_FR',
        'pt_PT',
        'ar_AE'];
    return langTypePool.find(type => type.indexOf(langTypeKey) === 0) || 'zh_CN'
}

export function isE10Self() {
    if (localStorage.getItem("___test_fkjsjdfs")) {
        return true;
    }
    return window.location.host === 'www.e-cology.com.cn'
}


/**
 * 时间字符串截取
 * @param time 时间字符串
 * @param len 截取长度
 * @returns
 */
export function getSystemFormatTime(time: any, len = 9) {
    time = window?.weappUi?.DatePicker?.getLocaleDateTime(time)
    if (!time) {
        return "";
    }
    time = time + ""
    if (time.length > len) {
        time = time.slice(0, time.length - len)
    }
    return time
}

export function isYunTeams() {
    return window.location.host.indexOf("weapp.yunteams.cn") === 0
}

export function isThirdSSO() {
    return window.TEAMS?.loginAccountInfo?.loginType === 'THIRDSSO'
}

export function isLoginTypeEb() {
    return window.TEAMS?.loginAccountInfo?.loginType?.indexOf("EB") === 0;
}